import { getAggregateError, } from "@bracket/catch";
import { SCHEMA, } from "@bracket/chainography/schema";
import type { EthereumAddress, } from "@bracket/types";
import type { Abi, } from "viem";
import type { ContractFunctionArgs, ContractFunctionName, ContractName, } from "./types";


// export async function props<CN extends ContractName, CFN extends ContractFunctionName<CN>>( contract: CN, functionName: CFN, config: Config, ...args: ContractFunctionArgs<CN, CFN> ): Promise<ReturnType<typeof shim[CN][CFN]["props"]>> {
export function contract<CN extends ContractName, CFN extends ContractFunctionName<CN>>( contract: CN, functionName: CFN, ...args: ContractFunctionArgs<CN, CFN> ): { address: EthereumAddress; abi: Abi; contract: CN; functionName: CFN; args: ContractFunctionArgs<CN, CFN>; ttl?: number; baked?: unknown; } {
	try {
		const { props, ttl, baked, } = SCHEMA[contract][functionName];
		return { ...props(...args), contract, ttl, baked, };
	}
	catch(err) {
		console.log(">>>", contract, functionName, args);
		const { props, ttl, baked, } = SCHEMA[contract][functionName];
		console.log("2>>>", props(...args));
		throw getAggregateError(err, `@bracket/chainography::contract failed for contract ${String(contract)} function ${String(functionName)} - ${err instanceof Error ? err.message : "without error instance"}`);
	}
}
